export default __webpack_public_path__ + "static/media/notify.8a305396.png";